import NoMealsIcon from '@mui/icons-material/NoMeals';
import { Box, Stack, Typography } from '@mui/material';
import { MenuItem } from 'interfaces/MenuInterface';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { PrimaryActionButton } from '../../ExploreRestaurant/components/PrimaryActionButton';
import { MenuItemCard } from '../components/MenuItemCard';
import { useCart } from '../context/CartContext';
import { getGuestOrderMenuActionLabel } from 'Utils/helpers/getGuestOrderInstructions';

export const RestaurantMenuList: React.FC<{
  menuItems: MenuItem[];
}> = ({ menuItems }) => {
  const { cart } = useCart();

  const navigate = useNavigate();
  const { restaurantId } = useParams();
  const guestOrderMenuActionLabel = getGuestOrderMenuActionLabel(restaurantId);
  const goToOrder = (id: number) => {
    if (restaurantId) {
      navigate('/explore/'.concat(restaurantId, `/cart/${id}`));
    }
  };

  const boxProperties = {
    width: '100%',
    position: 'fixed',
    bottom: 0,
    padding: 2,
    textAlign: 'center',
    display: 'flex-box',
    flexDirection: 'column',
    left: 0,
  };

  return (
    <>
      <Stack spacing={2}>
        {/* Removed mb={10} */}
        {menuItems.length == 0 && (
          <Stack alignItems='center' spacing={2}>
            <NoMealsIcon />
            <Typography variant='body1'>No available options</Typography>
          </Stack>
        )}
        {menuItems.map((menuItem) => {
          const _menuItem = { ...menuItem };
          if (_menuItem.additionalDiets && _menuItem.additionalDiets.length > 0 && _menuItem.additionalDiets.includes('halal')) {
            //NOTE: temporary hack
            //if menuItem contains halal in the additionalDiets, add halal to the diets of every menuitemCustomizationOption
            _menuItem.menuItemCustomizations.forEach((customization) => {
              const customizationDiets = customization.diets || [];
              customizationDiets.push('halal');
              customization.diets = customizationDiets;
              customization.menuItemCustomizationOptions.forEach((option) => {
                const optionDiets = option.diets || [];
                optionDiets.push('halal');
                option.diets = optionDiets;
              });
            });
          }
          return <MenuItemCard key={_menuItem.id} menuItem={_menuItem} />;
        })}
      </Stack>

      {cart && cart.orders.length > 0 && cart.orders[0].items.length > 0 && (
        <Box sx={boxProperties}>
          <Box mb={1}>
            <PrimaryActionButton
              title={guestOrderMenuActionLabel.concat(' (',
                cart.orders[0].items.length.toString(),
                ')'
              )}
              onClick={() => {
                goToOrder(1);
              }}
            />
          </Box>
        </Box>
      )}
    </>
  );
};

// BENNETT
// Name
// Email
// Phone number
// Password

// Thank you beneath after click

// Diets up to 2?
